import NumberInputDisplay from '../../src/legacy/NumberInputDisplay';
export default NumberInputDisplay;
